/** @format */
import { Pipe, PipeTransform } from '@angular/core';
import { Education } from 'common-typescript/types';
import { EducationEntityService } from '../service/education-entity.service';

@Pipe({
    name: 'isAgreementStudy',
    standalone: false,
})
export class IsAgreementStudyPipe implements PipeTransform {
    constructor(private educationEntityService: EducationEntityService) {}

    transform(value: Education): boolean {
        return this.educationEntityService.isAgreementStudy(value);
    }
}
